import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/coatarms.svg'


const _hoisted_1 = { class: "h-80vh" }
const _hoisted_2 = { class: "d-table" }
const _hoisted_3 = { class: "d-table-cell" }
const _hoisted_4 = {
  class: "card border-0 box-shadow border-radius-10 mb-4 w-100",
  style: {"max-width":"500px","margin":"auto"}
}
const _hoisted_5 = { class: "card-body p-30" }
const _hoisted_6 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-center mb-4" }, [
              _createElementVNode("h4", { class: "fs-20 fw-semibold mb-2" }, "E-GCR Portal"),
              _createElementVNode("div", {
                class: "d-flex justify-content-center align-items-center cw-293",
                style: {"margin-left":"80px"}
              }, [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    style: {"width":"50px","height":"50px","text-align":"right"},
                    src: _imports_0,
                    alt: "logo"
                  })
                ]),
                _createElementVNode("div", {
                  class: "lc-wordmark",
                  role: "img",
                  "aria-label": "Contoller and Account General"
                }, [
                  _createElementVNode("span", { class: "lc-line1" }, [
                    _createElementVNode("span", { class: "lc-primary" }, "e-"),
                    _createElementVNode("span", { class: "lc-accent" }, "GCR PORTAL")
                  ]),
                  _createElementVNode("span", { class: "lc-line2" }, "THE CONTROLLER AND ACCOUNTANT GENERAL")
                ])
              ]),
              _createElementVNode("h4", { class: "fs-18 fw-semibold mb-2" }, "You Are Logged out")
            ], -1)),
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "default-btn w-100 d-block text-center text-white text-decoration-none"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode(" Sign In ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}